export default "{\n    \"servicedByText\": \"Serviced by {{servicePartner}}\"\n}\n"